import * as React from 'react';
import { cn } from './cn';

/**
 * EDS Table — Design Bible §7.4.
 * Responsive: horizontal scroll on small screens. Header is muted uppercase.
 * Numerics should use `align="right"` + `tabular-nums`.
 */
export const Table = React.forwardRef<HTMLTableElement, React.TableHTMLAttributes<HTMLTableElement>>(
  ({ className, ...props }, ref) => (
    <div className="w-full overflow-x-auto rounded-eds-md border border-eds-border">
      <table ref={ref} className={cn('w-full border-collapse font-eds-body text-sm', className)} {...props} />
    </div>
  ),
);
Table.displayName = 'EdsTable';

export const THead = React.forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(
  ({ className, ...props }, ref) => (
    <thead ref={ref} className={cn('bg-eds-surface-2', className)} {...props} />
  ),
);
THead.displayName = 'EdsTHead';

export const TBody = React.forwardRef<HTMLTableSectionElement, React.HTMLAttributes<HTMLTableSectionElement>>(
  ({ className, ...props }, ref) => (
    <tbody ref={ref} className={cn('divide-y divide-eds-border', className)} {...props} />
  ),
);
TBody.displayName = 'EdsTBody';

export const TR = React.forwardRef<HTMLTableRowElement, React.HTMLAttributes<HTMLTableRowElement>>(
  ({ className, ...props }, ref) => (
    <tr ref={ref} className={cn('hover:bg-eds-surface-2/60', className)} {...props} />
  ),
);
TR.displayName = 'EdsTR';

export const TH = React.forwardRef<
  HTMLTableCellElement,
  React.ThHTMLAttributes<HTMLTableCellElement>
>(({ className, scope = 'col', ...props }, ref) => (
  <th
    ref={ref}
    scope={scope}
    className={cn(
      'px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wider text-eds-muted-fg',
      className,
    )}
    {...props}
  />
));
TH.displayName = 'EdsTH';

export const TD = React.forwardRef<HTMLTableCellElement, React.TdHTMLAttributes<HTMLTableCellElement>>(
  ({ className, ...props }, ref) => (
    <td ref={ref} className={cn('px-4 py-3 text-eds-fg align-middle', className)} {...props} />
  ),
);
TD.displayName = 'EdsTD';

export default Table;
